import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";

export const LOGIN_EXPIRATION = 30 * 60 * 1000; // 30 minutes

export const getDomainUrl = (subdomain) => {
    const isLocalDev = window.location.hostname === 'localhost';
    if (isLocalDev) {
        if (subdomain === 'spacefana') {
            return `http://localhost:3000`;
        }
        if (subdomain === 'sbms') {
            return `http://localhost:3001`;
        }
        else {
            return `https://${subdomain}.saberdevusa.xyz`;
        }
    }
    if (!window.location.hostname.includes("sbms.")) { // high side deployments use paths not subdomains
        return `${window.location.origin}/${subdomain}`;
    }
    return window.location.origin.replace("sbms", subdomain);
};

export const getPathUrl = (path, subdomain = "sbms") => {
    // path is: /dashboards
    // origin is: https://sbms.saberdevusa.xyz
    // high side origin is: https://domain/sbms
    const origin = getDomainUrl(subdomain);
    return origin + path;
};

export const plural = (word, count) => count === 1 ? word : `${word}s`;

export const checkMessageOrigin = (event) => {
    const spacefanaURL = getDomainUrl('spacefana');
    if(event.origin !== spacefanaURL) {
        console.warn(`Got ${event.data.type} message but from incorrect origin`, event.origin, "vs", spacefanaURL);
        return false;
    }
    return true;
};

export const TooltipButton = ({tooltip, props, wrapDiv=false, children}) => {
    const button = <Button
        data-testid={tooltip}
        {...props}
    >
        {children}
    </Button>;
    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip>
                    {tooltip}
                </Tooltip>
            }
        >
            {wrapDiv ? <div>{button}</div> : button}
        </OverlayTrigger>
    );
};

export const isValidEmail = (email) => {
    // simplified and doesn't use regex 
    // because of sonarqube "vulnerable to super-linear runtime due to backtracking" warning
    if(!email) return false;
    const i1 = email.indexOf("@");
    if(i1 <= 0) return false;
    const sub = email.substring(i1);
    const i2 = sub.indexOf(".");
    return i2 > 0 && i2 < sub.length-1;
};

export const isVowel = (x) => {
    return /[aeiouAEIOU]/.test(x);
};

// returns "a {word}" if consonant, "an {word}" if vowel
export const vowelize = (word) => {
    if (word?.length > 0) {
        return (isVowel(word[0]) ? "an " : "a ") + word;
    }
    return word;
};

export const LoadingSpinner = () => (
    <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        />
);

const checkDomain = (domains) => {
    return domains.some(domain => window.location?.hostname?.includes(domain));
};

export const isDev = () => {
    return checkDomain(["localhost", "saberdevusa.xyz"]);
}